import React from "react";
import { Spinner as BS_Spinner } from "react-bootstrap";
import "./style.css";

const Spinner = () => {
  return <BS_Spinner animation="border" className={"default-spinner"} />;
};

export default Spinner;
